import '../scss/contact.scss';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import emailjs from "@emailjs/browser";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaWhatsapp,FaClock } from 'react-icons/fa';
import Slider from 'react-slick';
import SocialButton from '../components/SocialButton';
import LoadingBar from "react-top-loading-bar";

function ContactPage() {

  const toastOptions = {
    autoClose: 700,
    pauseOnHover: true,
  }
  const ref = useRef(null);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault(); // prevents the page from reloading when you hit “Send”
    ref.current.continuousStart();
    emailjs.sendForm('service_rk3bsqa', 'template_ww31izm', form.current, 'SGdJMhoFjQHbith_Y')
      .then((result) => {
        ref.current.complete();
        toast('Email Send Successfully', toastOptions);
        document.getElementById("mail_contact_form").reset();
      }, (error) => {
        ref.current.complete();
        toast('Email is not Send Successfully', toastOptions);// show the user an error
      });
  };

  const slides = [
    { url: 'assets/slider-main/bg9.jpg', head: '', title: '', subTitle: '' },
  ];

  let mainSettings = {
    infinite: true,
    autoplay: true,
    speed: 1000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 960,
        mainSettings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        mainSettings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };


  return (
    <div className="body-inner">
       <LoadingBar color="#f11946" ref={ref} />
      <section className="banner-carousel banner-carousel-1 mb-0">
        <div className='contactHomeText'>
          <h1>Contact Us</h1>
          <Link to='/' className='homeTextLink'>Home</Link> | Contact Us
        </div>
        <ToastContainer />
        <div className='mainContainerStyles'>
          <Slider {...mainSettings}>
            {slides.map((image) => (
              <img loading="lazy" className='contactImgContainer' src={image.url} alt='MyVisa Priority' />
            ))}
          </Slider>
        </div>
      </section>
      <section id="main-container" className="infoContainer">
        <div className="container">
          <div className='contactTitleBox'>
            <div className="row text-center">
              <div className="col-lg-12">
                <h2 className="contactTitle">Get In Touch!</h2>
              </div>
            </div>
          </div>
          <div id="contact_form" className="row">
            <div className="col-md-6">
              <div className="tsContact">
              <span className="ts-service-icon d-flex">
                  <FaClock />
                  <h6>Operating Hours</h6>
                </span>
                <p className='boxText'>
                Monday - Friday  : 9:00 AM - 6:00 PM
                </p>
              </div>

              <div className="tsContact">
                <span className="d-flex">
                  <FaMapMarkerAlt />
                  <h6>Address</h6>
                </span>
                <p className='boxText'>
                Fahidi Heights Office #1703B, 1B, 17th Floor,Khalid Bin Al Waleed Road - Bank Street, near Sharaf DG Metro Station, AL Fahidi, Dubai, United Arab Emirates
                </p>
              </div>
              <div className="tsContact">
                <span className="d-flex">
                  <FaEnvelope />
                  <h6>Email</h6>
                </span>
                <p className='boxText'>visa@myvisapriority.com</p>
              </div>
              <div className="tsContact">
                <span className="d-flex">
                  <FaPhoneAlt />
                  <h6>Call Us</h6>
                </span>
                <p className='boxText'>+971 503096788</p>
                <span className="d-flex">
                  <FaWhatsapp />
                  <h6>WhatsApp</h6>
                </span>
                <p className='boxText'>+971 503096788</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className='contextForm'>
              <form ref={form} onSubmit={sendEmail} accept-charset="UTF-8" id='mail_contact_form'>
                    <div className="form-group">
                      <label>Name</label>
                      <input className="form-control form-control-name" required="required" type="text" name="contact_name" id="contact_name" />
                    </div>
                    
                    <div className="form-group">
                      <label>Email</label>
                      <input className="form-control form-control-name" type="text" name="contact_email" id="contact_email" />
                    </div>

                    <div className="form-group">
                      <label>Mobile Number</label>
                      <input className="form-control form-control-name" required="required" type="text" name="contact_mobile_number" id="contact_mobile_number" />
                    </div>

                    <div className="form-group">
                      <label>Location</label>
                      <input className="form-control form-control-name" required="required" type="text" name="contact_location" id="contact_location" />
                    </div>

                    <div className="form-group">
                      <label>Message</label>
                      <textarea className="form-control form-control-message" rows="3" name="message" id="contact_message">
                      </textarea>
                    </div>

                    <div className="text-center"><br />
                      <input type="submit" name="commit" value="Submit" className="btn btn-primary solid blank" data-disable-with="Send" />
                    </div>
              </form>
              </div>      
              </div>

          </div>
        </div>
      </section>
      <section id="main-container" className="infoContainer">
        <div className="container">
      <div className="contactSecBox">
          <div className='row'>
            <div className="col-md-12">
              <div className='contactTitleBox'>
                <h2 className="contactTitle">Find Our Location</h2>
              </div>
              <iframe title='Get In Touch!' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1804.190616546794!2d55.2984855!3d25.2577579!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f430c5c75f521%3A0x23c1b37d09450d52!2sCentral%20Mall!5e0!3m2!1sen!2sin!4v1679290352237!5m2!1sen!2sin" style={{ width: '100%', height:'420px',  border: '0px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
            </div>
          </div>
        </div>
        </div>
      </section>
      <div className='infoContainer'></div>
      <SocialButton/>
    </div>
  )
}

export default ContactPage